export default "__VITE_ASSET__41f8feca__"